var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#96F",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.625.778C11.071-.425 8.81-.21 7.528 1.263L6.455 2.506c-.21.242-.27.575-.157.872.112.297.38.514.702.568.323.054.65-.062.86-.305L8.933 2.4c.316-.366.772-.592 1.264-.627.491-.036.977.123 1.345.44.73.656.798 1.752.153 2.488l-2.23 2.584-.021.022c-.12.134-.26.25-.414.342-.74.445-1.702.32-2.295-.297-.345-.356-.923-.376-1.293-.043-.37.333-.39.893-.047 1.25.84.874 2.08 1.278 3.296 1.075.187-.031.371-.077.551-.136.636-.207 1.2-.581 1.63-1.08l2.224-2.577c.64-.747.945-1.709.848-2.674-.088-.936-.564-1.797-1.319-2.388z",
    transform: "translate(1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.038 10.348l-.958 1.11c-.634.746-1.76.877-2.558.298-.388-.295-.635-.729-.687-1.203-.051-.475.098-.949.413-1.315l2.27-2.629.016-.018c.12-.133.259-.249.414-.341.668-.403 1.527-.345 2.13.144.07.056.136.118.197.185.176.193.431.302.697.298.264-.003.512-.118.68-.313l.012-.013c.29-.332.283-.819-.016-1.144-.705-.772-1.723-1.209-2.788-1.195-1.065.015-2.07.478-2.754 1.269L.843 8.1c-1.269 1.484-1.085 3.675.414 4.941.735.614 1.696.914 2.663.832.114-.009.227-.023.34-.042.87-.148 1.659-.587 2.228-1.24l.955-1.108c.324-.375.273-.934-.115-1.248-.388-.313-.965-.263-1.29.112z",
    transform: "translate(1)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.e53ef5d1.svg";
export { ForwardRef as ReactComponent };